import React from 'react'
import { Button } from './components/buttons/Button'
import { SegmentCard } from './components/data-display/SegmentCard'
import { Icon } from './Icon'
import { IMG } from './images'
import { Reveal, Section, SectionHead } from './primitives'
import { SERVICE_CATALOG } from './serviceData'

export function TrustBar() {
  const items = [
    'ISO 9001 Certified', 'IEC 62619 Safety', '1,200+ Projects Delivered',
    '850 MWh Energy Capacity', 'Industry 4.0 Ready', 'Make in India',
    'AIS-156 Compliant', 'In-House R&D',
  ];
  const loop = [...items, ...items];
  return (
    <div style={{
      background: 'var(--surface-inverse-2)', borderTop: '1px solid var(--border-on-dark)',
      borderBottom: '1px solid var(--border-on-dark)', padding: '18px 0', overflow: 'hidden',
    }}>
      <div className="adr-marquee" style={{ display: 'flex', gap: 0, width: 'max-content' }}>
        {loop.map((t, i) => (
          <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 14, padding: '0 32px', flexShrink: 0 }}>
            <Icon name="check-circle-2" style={{ width: 18, height: 18, color: 'var(--energy-bright)' }} />
            <span style={{ fontFamily: 'var(--font-ui)', fontWeight: 600, fontSize: 15, color: 'rgba(255,255,255,0.86)', whiteSpace: 'nowrap' }}>{t}</span>
          </span>
        ))}
      </div>
    </div>
  );
}

export function AboutPreview({ onNavigate }) {
  return (
    <Section label="About">
      <div style={{ display: 'grid', gap: 56, alignItems: 'stretch' }} className="adr-split">
        <Reveal variant="scale" style={{ position: 'relative', minHeight: 420 }}>
          <div className="adr-hov-img" style={{ position: 'absolute', inset: 0, borderRadius: 'var(--radius-2xl)', overflow: 'hidden', boxShadow: 'var(--shadow-lg)' }}>
            <div style={{ position: 'absolute', inset: 0, backgroundImage: `url("${IMG('factory-2')}")`, backgroundSize: 'cover', backgroundPosition: 'center', filter: 'blur(18px) brightness(0.55)', transform: 'scale(1.12)' }} />
            <img src={IMG('factory-2')} alt="ADIRATH facility" style={{ position: 'relative', zIndex: 1, width: '100%', height: '100%', display: 'block', objectFit: 'contain' }} />
          </div>
        </Reveal>

        <div>
          <SectionHead
            eyebrow="About ADIRATH EEE Energy Private Limited"
            title="Empowering Industries With Advanced Energy Solutions & Industrial Automation"
          />
          <p style={{ color: 'var(--text-body)', lineHeight: 1.7, margin: '16px 0 0', fontSize: 'var(--fs-lead)' }}>
            <strong>EEE Energy Private Limited</strong> designs and manufactures advanced <strong>Lithium-Ion, LiFePO₄, and LTO Battery Systems</strong>, <strong>Battery Energy Storage Systems (BESS)</strong>, <strong>Industrial Mobility Batteries</strong>, and <strong>Robotics & Automation Solutions</strong>. From concept and engineering to manufacturing and lifetime support, we deliver reliable, customized power solutions built to global quality standards under the brand name <strong>ADIRATH</strong>.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 18, margin: '28px 0 32px' }}>
            {[
              ['cpu', 'In-house R&D', 'BMS, controls & new product development'],
              ['factory', 'Vertical manufacturing', 'Cell-to-pack under one roof'],
              ['leaf', 'Sustainability first', 'Solar + storage, circular design'],
              ['globe', 'Global standards', 'TUV ISO 9001, 14001, 45001 CE, RoHS'],
            ].map(([ic, t, d]) => (
              <Reveal key={t} variant="up" style={{ display: 'flex', gap: 12 }}>
                <span style={{ flexShrink: 0, width: 40, height: 40, borderRadius: 10, background: 'var(--energy-soft)', color: 'var(--success)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Icon name={ic} style={{ width: 20, height: 20 }} />
                </span>
                <div>
                  <div style={{ fontFamily: 'var(--font-heading)', fontWeight: 700, color: 'var(--text-strong)', fontSize: 15 }}>{t}</div>
                  <div style={{ fontSize: 13.5, color: 'var(--text-muted)', lineHeight: 1.4 }}>{d}</div>
                </div>
              </Reveal>
            ))}
          </div>
          <Button variant="primary" iconRight={<Icon name="arrow-right" style={{ width: 18, height: 18 }} />} onClick={() => onNavigate('About Us')}>Discover ADIRATH</Button>
        </div>
      </div>
    </Section>
  );
}

export function WhyUs() {
  const cards = [
    ['factory', 'Advanced Manufacturing', 'Gigafactory-grade cell assembly, automated pack lines and rigorous QA.', 'big'],
    ['flask-conical', 'R&D Driven Innovation', 'Dedicated lab for BMS, chemistry and new product development.', ''],
    ['leaf', 'Sustainable Energy Focus', 'Solar + storage and circular, low-carbon design.', ''],
    ['layers', 'End-To-End Solutions', 'From design to deployment and lifetime support.', ''],
    ['users', 'Expert Engineering Team', 'Power, robotics and automation specialists under one roof.', 'wide'],
  ];
  return (
    <Section label="Why Us" style={{ background: 'var(--surface-page)' }}>
      <SectionHead align="center" max={760}
        eyebrow="Why Choose Us"
        title="Built for reliability, engineered for the future."
        sub="Five reasons leading industries trust ADIRATH to power their operations." />
      <div className="adr-bento" style={{
        display: 'grid', gap: 20, marginTop: 48,
      }}>
        {cards.map(([ic, t, d, span], i) => (
          <Reveal key={t} variant="up" delay={(i % 3) * 0.06}
            style={{ gridColumn: 'span 1' }}>
            <WhyCard ic={ic} t={t} d={d} accent={i === 0} />
          </Reveal>
        ))}
      </div>
    </Section>
  );
}

export function WhyCard({ ic, t, d, accent }) {
  const [h, setH] = React.useState(false);
  return (
    <div onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)}
      style={{
        height: '100%', borderRadius: 'var(--radius-xl)', padding: 'var(--space-6)',
        background: accent ? 'var(--grad-electric)' : 'var(--surface-card)',
        border: accent ? '1px solid transparent' : '1px solid var(--border-subtle)',
        color: accent ? '#fff' : 'var(--text-body)',
        transform: h ? 'translateY(var(--lift))' : 'none',
        boxShadow: h ? (accent ? 'var(--glow-blue)' : 'var(--glow-green)') : 'var(--shadow-sm)',
        transition: 'transform var(--dur-med) var(--ease-out), box-shadow var(--dur-med) var(--ease-out)',
      }}>
      <span style={{
        width: 52, height: 52, borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: accent ? 'rgba(255,255,255,0.14)' : 'var(--accent-soft)',
        color: accent ? 'var(--energy-bright)' : 'var(--accent)', marginBottom: 20,
      }}>
        <Icon name={ic} style={{ width: 26, height: 26 }} />
      </span>
      <h3 style={{ fontFamily: 'var(--font-heading)', fontWeight: 700, fontSize: 'var(--fs-h4)', margin: '0 0 8px', color: accent ? '#fff' : 'var(--text-strong)' }}>{t}</h3>
      <p style={{ margin: 0, fontSize: 14.5, lineHeight: 1.55, color: accent ? 'rgba(255,255,255,0.82)' : 'var(--text-muted)' }}>{d}</p>
    </div>
  );
}

export function BusinessSegments({ onNavigate }) {
  const segs = [
    ['battery-charging', 'Battery Energy Storage', 'Residential to utility-scale ESS — low & high voltage, C&I and grid.', 'bess'],
    ['forklift', 'Industrial Mobility Batteries', 'AGV, AMR, ASRS, EV, marine and medical mobility power systems.', 'mobility'],
    ['bot', 'Robotics System Integration', 'Robot integration, pick & place, welding and custom robotics.', 'robotics'],
    ['cog', 'Industrial Automation', 'Machine tending, vision systems, PLC/HMI and smart factory.', 'automation'],
    ['sun', 'Solar EPC Solutions', 'Rooftop, ground-mount, Solar + BESS and full EPC services.', 'solar'],
    ['rocket', 'New Product Development', 'Defence, aerospace, marine, railways, charging and BMS.', 'npd'],
  ];
  return (
    <Section label="Business Segments" dark style={{ background: 'var(--grad-hero)' }}>
      <SectionHead dark max={760}
        eyebrow="Business Segments"
        title="Multiple segments. One integrated clean-energy partner." />
      <div className="adr-seg-grid" style={{ display: 'grid', gap: 22, marginTop: 48 }}>
        {segs.map(([ic, t, d, img], i) => (
          <Reveal key={t} variant="up" delay={(i % 3) * 0.08}>
            <SegmentCard title={t} description={d}
              icon={<Icon name={ic} style={{ width: 26, height: 26 }} />}
              image={IMG(img)}
              onClick={() => onNavigate('Services')} />
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
